import { Link } from 'gatsby';
import React, { useState } from 'react';
import styled from "styled-components";
import KalkulackaImg from "../assets/img/kalkulacka.svg";
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"
import { useForm } from "react-hook-form";

import Telefon from "../assets/img/telefon.svg";
import Modal from '../pages/nabidka/prehled/Modal';
import axios from 'axios';

const ArticleFormularInner = styled.div`
  background: #F3F1EB;
  padding: 30px;
  border-radius: 10px;
  margin: 60px auto;

  @media (max-width: 400px) {
    padding: 20px;
    margin: 40px auto;
  }

  h2 {
    font-family: Visuelt-Medium,Helvetica !important;
    font-size: 23px !important;
    color: #0c1c31;
    margin: 0 !important; 

    @media (max-width: 900px) {
      font-size: 22px !important;
      line-height: 31px;
    }

    @media (max-width: 540px) {
      font-size: 20px !important;
      line-height: 28px;
    }
  }

  ul {
    padding: 0 !important; 

    li {
      font-family: Visuelt-Regular,Helvetica;
      font-size: 17px;
      color: #282828;
      line-height: inherit;
      margin: 0px auto;
      position: relative;
      list-style: none;
      padding-left: 20px;
      margin: 15px 0;

      &::before {
        position: absolute;
        left: 0;
        top: 2px;
        content: "";
        padding: 8px 16px 8px 8px;
        background-repeat: no-repeat;
        background-position: left center;
        background-size: 8px;
        background-image: url("data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.9565 0.0800942C19.7244 -0.427904 23.5804 1.49209 26.5764 5.51207C29.5724 9.53206 30.1324 12.204 29.9764 15C29.7204 19.568 27.6004 23.264 25.8484 25.692C24.0964 28.12 21.8084 30.016 17.6964 30C13.6684 29.984 6.36447 28.556 3.29648 24.932C0.228495 21.308 -0.727502 17.032 0.552494 11.96C1.83249 6.88807 4.18848 0.588092 11.9565 0.0800942Z' fill='%23bb984c'/%3E%3C/svg%3E%0A");
      }
    }
  }

  p {
    margin: 15px auto !important;
  }

  button {
    font-family: Visuelt-Medium;
    font-size: 18px;
    color: #000000;
    text-align: center;
    max-width: 290px;
    display: block;
    padding: 20px 0;
    border-radius: 5px;
    background: #e5ddc4;
    text-decoration: none;
    margin-top: 30px;
    cursor: pointer;
    width: 220px;
    border: 0;

    &:hover {
      background: #d9ceae;
    }
  }

  .support {
    display: flex;
    align-items: center;
    margin-top: 30px;

    @media (max-width: 500px) {
      display: block;
    }

    .rightSupp {
      margin-left: 25px;

      @media (max-width: 500px) {
        margin-left: 0;
        margin-top: 15px;
      }

      .phone {
        display: flex;
        align-items: center;

        padding: 0;
        background: none;
        margin: 0;

        img {
          height: 20px;
          margin-right: 12px;
          margin-top: -1px;
        }

        span {
          font-family: Visuelt-Medium;
          font-size: 24px;
          color: #0c1c31;
        }
      }

      .kDispozici {
        width: fit-content;
        margin: 0 auto;
        margin-top: 10px;

        @media (max-width: 500px) {
          margin-left: 0;
        }

        .greenDot {
          background: #49B25D;
          height: 10px;
          width: 10px;
          border-radius: 100%;
          animation: pulse 2s infinite;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-family: Visuelt-Medium;
          font-size: 16px;
          color: #48B15C;
          line-height: 24px;
          vertical-align: middle;
          margin-left: 10px;
        }

        @keyframes pulse {
          0% {
            opacity: 1;
          }

          50% {
            opacity: 0.25;
          }

          100% {
            opacity: 1;
          }
        }
      }
    }
  }

  .modalWrap {
    max-width: 400px;
  }

  .close {
    margin: 0;
    width: auto;
    padding: 0;
  }

  h3 {
    margin-top: 0 !important;
  }

  input {
    background: #FFFFFF;
    border: 1px solid #C8C8C8;
    border-radius: 5px;
    padding: 30px;

    @media (max-width: 850px) {
      padding: 20px;
    }

    textarea {
      width: 100%;
      resize: none;
      height: 150px;
      font-family: Visuelt-Regular;
      font-size: 16px;
      color: #000000;
      line-height: 25px;
      border: 0;
      border-bottom: 1px solid #D8D8D8;
      margin-bottom: -15px;
    }

    .errorMsgPrvni {
      font-family: Visuelt-Regular;
      line-height: 25px;
      font-size: 16px;
      color: #FF6060;
      margin: 0;
      margin-top: 20px;
    }

    .buttons {
      display: block;
      margin-top: 30px;

      .submit {
        font-family: Visuelt-Medium;
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
        background: #566FEF;
        border: 0;
        padding: 10px 0;
        width: 120px;
        border-radius: 5px;

        @media (max-width: 359px) {
          width: 110px;
        }

        &:hover {
          cursor: pointer;
        }
      }

      .zpet {
        font-family: Visuelt-Medium;
        font-size: 16px;
        color: #000;
        background: #efefef;
        text-align: center;
        border: 0;
        padding: 10px 0;
        width: 120px;
        border-radius: 5px;
        margin-left: 20px;

        @media (max-width: 359px) {
          width: 90px;
        }

        &:hover {
          cursor: pointer;
        }
      }
    }

    label {
      display: block;
      margin-bottom: 20px;

      span {
        display: block;
        font-family: Visuelt-Regular;
        font-size: 16px;
        color: #6C6C6C;
        line-height: 25px;
        margin-bottom: 8px;
      }

      input {
        display: block;
        width: calc(100% - 24px);
        max-width: 300px;
        background: #FFFFFF;
        border: 2px solid #D2D2D2;
        border-radius: 5px;
        padding: 10px;
        font-family: Visuelt-Regular;
        font-size: 16px;
        color: #000;
        line-height: 25px;

        &:focus {
          border: 2px solid #566FEF;
        }
      }

      .errorMsg {
        font-family: Visuelt-Regular;
        line-height: 25px;
        font-size: 16px;
        color: #FF6060;
        margin: 0;
        margin-top: 8px;
      }
    }

    .inputError {
      input {
        border: 2px solid #FF6060 !important;
      }

      span {
        color: #FF6060;
      }
    }

    .pridano {
      display: flex;
      align-items: center;

      img {
        width: 50px;
        margin-right: 20px;
      }

      span {
        font-family: Visuelt-Medium;
        font-size: 18px;
        color: #000;
      }
    }
  }

  label {
    display: block;
    margin-bottom: 20px;

    span {
      display: block;
      font-family: Visuelt-Regular;
      font-size: 16px;
      color: #6C6C6C;
      line-height: 25px;
      margin-bottom: 8px;
    }

    input {
      display: block;
      width: calc(100% - 24px);
      max-width: 300px;
      background: #FFFFFF;
      border: 2px solid #D2D2D2;
      border-radius: 5px;
      padding: 10px;
      font-family: Visuelt-Regular;
      font-size: 16px;
      color: #000;
      line-height: 25px;

      &:focus {
        border: 2px solid #566FEF;
      }
    }

    .errorMsg {
      font-family: Visuelt-Regular;
      line-height: 25px;
      font-size: 16px;
      color: #FF6060;
      margin: 0;
      margin-top: 8px;
    }
  }

  .inputError {
    input {
      border: 2px solid #FF6060 !important;
    }

    span {
      color: #FF6060;
    }
  }

  .pridano {
    display: flex;
    align-items: center;

    img {
      width: 50px;
      margin-right: 20px;
    }

    span {
      font-family: Visuelt-Medium;
      font-size: 18px;
      color: #000;
    }
  }

  .submit {
    width: 250px;
    margin-right: 30px;
    padding: 20px 0;
    font-family: Visuelt-Medium;
    font-size: 18px;
    text-align: center;
    border-radius: 3px;
    border: 0;
    margin-bottom: 20px;
    background: #243A58;
    color: #FFFFFF;

    &:hover {
      cursor: pointer;
      background: #1a2b42;
    }  
  }
`;

const ArticleFormular = () => {

  const { register, handleSubmit, errors, watch } = useForm();
  const onSubmit = data => handleForm(data);
  const [isModal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDone, setIsDone] = useState(false);
  

  const handleForm = (data) => {
    setIsLoading(true);

    axios.post(`https://formspree.io/f/xdopbwgv`, {status: "Nemovitosti nový kontakt", data: data}).then((a) => {
      setIsDone(true);
    });
  }




  return (
    <ArticleFormularInner>
      <Modal setOpen={setModal} isOpen={isModal}>
        <h3>Nechte nám na sebe kontakt, brzy se vám ozveme</h3>
        {!isDone ?
        <form onSubmit={handleSubmit(onSubmit)}>
          <label className={`${errors.name && "inputError"}`}>
            <span>Vaše jméno</span>
            <input ref={register({ required: true })} type="text" name="name"/>
            {errors.name && <div className="errorMsg">Toto pole je povinné</div>}
          </label>

          <label className={`${errors.tel && "inputError"}`}>
            <span>Telefonní číslo</span>
            <input ref={register({ required: true })} type="text" name="tel"/>
            {errors.tel && <div className="errorMsg">Toto pole je povinné</div>}
          </label>

          <label className={`${errors.email && "inputError"}`}>
            <span>E-mail</span>
            <input ref={register({ required: true })} type="email" name="email"/>

            {errors.email && <div className="errorMsg">Hesla se neshodují</div>}
          </label>

          <div className="buttons">
            <input className="submit" type="submit" value={(isLoading) ? "Načítání..." : "Pokračovat"} />
          </div>
        </form>
        :
        <p>Děkujeme</p>
        }
      </Modal>

      <h2>Rádi vám pomůžeme s oceněním nemovitosti nebo s jejím vyklizením</h2>
      <p>Pokud byste o takové služby měli zájem, nechte nám na sebe kontakt. Co nejdříve se vám potom ozveme a probereme vaše možnosti.</p>
      <button onClick={() => setModal(true)}>Nezávazně poptat</button>
    </ArticleFormularInner>
  );
}

export default ArticleFormular;
